/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2021. All Rights Reserved.
#*
#*===================================================================
*/
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { ACCOUNT_FEATURE_KEY, AccountState, accountReducer } from '@settings/store/reducers/account.reducer';
import {
  GlobalConfigState,
  GLOBAL_CONFIG_FEATURE_KEY,
  globalConfigReducer,
} from '@settings/store/reducers/global-config.reducer';
import { clusterReducer, ClusterState, CLUSTERS_FEATURE_KEY } from './clusters.reducer';
import { discountCodesReducer, DiscountCodeState, DISCOUNT_CODE_FEATURE_KEY } from './discount-code.reducer';


export const SETTINGS_STORE_KEY = 'settings';

export interface SettingsState {
  [ACCOUNT_FEATURE_KEY]: AccountState;
  [GLOBAL_CONFIG_FEATURE_KEY]: GlobalConfigState;
  [CLUSTERS_FEATURE_KEY]: ClusterState;
  [DISCOUNT_CODE_FEATURE_KEY]: DiscountCodeState;
}

export const reducerMap: ActionReducerMap<SettingsState> = {
  [ACCOUNT_FEATURE_KEY]: accountReducer,
  [GLOBAL_CONFIG_FEATURE_KEY]: globalConfigReducer,
  [CLUSTERS_FEATURE_KEY]: clusterReducer,
  [DISCOUNT_CODE_FEATURE_KEY]: discountCodesReducer,
};

export const getSettingsState = createFeatureSelector<SettingsState>(SETTINGS_STORE_KEY);
